import { Form, Heading, Text } from '@digitools/honest-ui';
import React from 'react';
import useExperience from 'src/hooks/useExperience';
import useTranslate from 'src/hooks/useTranslate';
import StepperButtons from '../../components/StepperButtons';
import { ReviewText } from '../../constants/ReviewText';
import AccommodationDetails from './AccommodationDetails';
import DisclaimerContent from './DisclaimerContent';
import ReviewAboutYou from './ReviewAboutYou';
import ReviewGettingStarted from './ReviewGettingStarted';
import ReviewSubmitButton from './ReviewSubmitButton';
import { Experience } from "src/types/Experience";
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
// ReviewSubmitButton submits from its own click handler, as it did with AccessibleForm.
// The Form is here because honest-ui Checkbox (DisclaimerContent) needs Form context.
const noFormSubmit = () => { };
const Review = () => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    return (<div>
      <Heading as='h2' visualLevel='h3' weight='bold' color='secondary' className='hui-mb-xl'>
        {t(ReviewText.pageTitle)}
      </Heading>
      {/* Form takes no data-* props, so the test id sits on a wrapper */}
      <div data-testid='test-review'>
        <Form onSubmit={noFormSubmit}>
          <ReviewGettingStarted />
          <ReviewAboutYou displayButton={true}/>
          <AccommodationDetails displayButton={true}/>
          {experience === Experience.EMPLOYEE && <DisclaimerContent />}
          {/* Equal space above and below the buttons. The wrapper's margins collapse with the
            disclaimer's (or the request list's) margin-bottom above and the buttons' own
            margin-top, so both gaps come out at exactly --spacing-xl-3. The bottom gap can't
            go on the footnote: legacy.scss zeroes margin-top on a <p> after a sibling. */}
          <div style={{ marginBlock: 'var(--spacing-xl-3)' }}>
            <StepperButtons last lastButton={<ReviewSubmitButton />} type="continue" analyticsPageName='review'/>
          </div>
          <Text as='p' size='sm' style={{ color: 'var(--color-text-tertiary)' }}>
            <sup>1</sup>
            {CustomEmployeeText(t(ReviewText.disclaimerFooterText))}
          </Text>
        </Form>
      </div>
    </div>);
};
export default React.memo(Review);
